import { withHydrate } from '@relay/react/hooks';
import ChevronUp from '@img/icons/icon-chevron-up.svg';
import React, { useEffect, useRef, useState } from 'react';
import S from './ScrollToTop.styles';
import { jsx as _jsx } from "react/jsx-runtime";
export let ScrollToTopTheme = /*#__PURE__*/function (ScrollToTopTheme) {
  ScrollToTopTheme[ScrollToTopTheme["DEFAULT"] = 0] = "DEFAULT";
  ScrollToTopTheme[ScrollToTopTheme["ROUNDED_RED"] = 1] = "ROUNDED_RED";
  return ScrollToTopTheme;
}({});
const ScrollToTop = ({
  theme = ScrollToTopTheme.DEFAULT
}) => {
  const scrollRef = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const body = document.querySelector('body');
    const scrollFunc = () => {
      if (body) {
        setVisible(window.scrollY > body.clientHeight / 2);
      }
    };
    if (body) {
      window.addEventListener('scroll', scrollFunc);
    }
    return () => {
      window.removeEventListener('scroll', scrollFunc);
    };
  }, []);
  return /*#__PURE__*/_jsx(S.Wrapper, {
    visible: visible,
    ref: scrollRef,
    themeOption: theme,
    onClick: () => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    },
    children: /*#__PURE__*/_jsx(ChevronUp, {})
  });
};
export const clientConfig = {
  hydrate: 'always'
};
export default withHydrate(ScrollToTop, 'ScrollToTop', 'hybrid');
